module.exports = function ($window) {
    return $window.document;
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex-web/src/$document.js
// module id = 556
// module chunks = 40